import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";

import { Area } from '../models/area.model';
import { ResponseModel } from '../models/response.model';
import { DataFilterViewModel } from '../view-model/dataFilter.viewModel';
import { BaseModel } from '../models/base.model';
import { GeneralService } from './general.service';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class AccountCustomerServices extends GeneralService {
  constructor(protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(httpClient, persistenceService, environment.apiCusUrl, "Account");
  }

    async getAllBank(): Promise<ResponseModel> {
        return await super.getCustomApi("GetBankAll", null).toPromise();
    }
    async getBranchBy(bankId: any): Promise<ResponseModel> {
        let httpParams = new HttpParams();
        httpParams = httpParams.append('bankId', bankId);
        return await super.getCustomApi("GetBranchBy", httpParams).toPromise();
    }
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/services/accountCustomer.service.ts